import React, { ReactElement } from 'react';
import { useTranslation } from 'utils/localization';
import InfoBox from 'components/boxes/InfoBox';
import styles from './PasswordHelp.module.scss';

const Info = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={styles.passwordFormatTitle}>
                <span>{t('Info.title')}</span>
            </div>

            <InfoBox
                variant="danger"
                title={t('Info.warningTitle')}
                message={t('Info.warningMessage')}
                className={styles.warningBox}
            />

            <div>{t('Info.list1')}</div>
        </div>
    );
};

export default Info;
